/* Darlin — Judge.me media loader shim.
 * Horizon scrolls the page inside .page-wrapper, so the window never fires
 * scroll events. Judge.me's lazy-loader waits for exactly those events, which
 * leaves gallery and review photos stuck on data-src forever. This shim swaps
 * data-src in when the reviews widget approaches the viewport (IntersectionObserver
 * works regardless of scroll mechanism), and nudges Judge.me's own listeners.
 */
(function () {
  'use strict';

  function loadJudgemeMedia() {
    var imgs = document.querySelectorAll(
      '.jdgm-gallery img[data-src], .jdgm-rev__pic-img[data-src], .jdgm-rev__pic img[data-src]'
    );
    imgs.forEach(function (img) {
      if (!img.getAttribute('src')) img.setAttribute('src', img.getAttribute('data-src'));
    });
    document.querySelectorAll('.jdgm-gallery [data-background-image], .jdgm-rev__pic [data-background-image]').forEach(function (el) {
      if (!el.style.backgroundImage || el.style.backgroundImage === 'none') {
        el.style.backgroundImage = 'url("' + el.getAttribute('data-background-image') + '")';
      }
    });
    window.dispatchEvent(new Event('scroll'));
    window.dispatchEvent(new Event('resize'));
  }

  function init() {
    var widget = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-rev-widg');
    if (!widget) return;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries, io) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadJudgemeMedia();
        });
      }, { rootMargin: '800px' }).observe(widget);
    }
    /* Judge.me injects the widget body late — retry on a timer as a fallback. */
    var runs = 0;
    var timer = setInterval(function () {
      loadJudgemeMedia();
      if (++runs >= 12) clearInterval(timer);
    }, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
